export default __webpack_public_path__ + "static/media/avatar.3a451293.png";